import { __extends } from "tslib";
import { ValueObject } from '../../base/ddd-types/value-object';
var NotifyUserInfo = /** @class */ (function (_super) {
    __extends(NotifyUserInfo, _super);
    function NotifyUserInfo(jsonObj) {
        var _this = _super.call(this) || this;
        /**
         * ValueObject的属性必须在这里初始化了， 才能正确的使用equals和jsonObj方法
         */
        _this.avatar = '';
        _this.nick = '';
        _this.uid = '';
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    return NotifyUserInfo;
}(ValueObject));
export { NotifyUserInfo };
